import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Input, Button, Layout, Typography, Alert, Result, Space, Flex } from 'antd'
import { LeftBar } from '../componentes/leftBar';
import StringMask from "string-mask";
import api from '../service/axios'
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router-dom';
import { responseMessage } from '../service/util';


const DELIMITERS = [".", "-", "/"];
const CNPJ_MASK = "00.000.000/0000-00";

const { Content } = Layout

function removeTrailingCharIfFound(str, chars) {
    let result = str;

    chars.forEach(c => {
        if (str[str.length - 1] === c) {
            result = str.slice(0, str.length - 1);
        }
    });

    return result;
}

function formatValue(str) {
    const unmaskedValue = str.replace(/[.\-\/]/g, "").trim();
    let mask = CNPJ_MASK;

    //   mask = CNPJ_MASK;

    const formatted = StringMask.process(unmaskedValue, mask);
    return removeTrailingCharIfFound(formatted.result, DELIMITERS);
}


export const ConsultaCRTCtrl = (props) => {

    const { code } = useParams()
    const [cnpj, setCnpj] = useState('')
    const [crq, setCrq] = useState('')
    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [data, setData] = useState(null)
    const [codigo, setCodigo] = useState(code)


    useEffect(() => {
      //  console.log(code)
        if (code)
            consulta()
    }, [])



    async function consulta() {
        try {
            if (!codigo) {
                addToast("Informe o Código de Autenticação para efetuar a consulta!", { appearance: 'error', autoDismiss: true });
                return
            }
            setLoading(true)
            const result = await api.get('api/v1.0/valida/crt', {
                params: { codigo: codigo }
            })
            setData(result.data)

        } catch (erro) {
            setData(undefined)
            addToast(responseMessage(erro.message), { appearance: 'error', autoDismiss: true });

        }
        setLoading(false)
    }


    function renderConsultar() {
        return <React.Fragment>
            <Flex vertical gap={5}>
                <Typography.Title level={4}>Comunicação de Responsabilidade Técnica</Typography.Title>
                <Flex justify='center'>AUTENTICAÇÃO DE DOCUMENTO</Flex>
                <br />
                <Input placeholder='Código de Autenticação' style={{ textAlign: 'center' }}
                    value={codigo}
                    onChange={event => {
                        setCodigo(event.target.value)
                    }} />

                <Button type="primary" style={{ marginTop: 15 }} loading={loading} block onClick={() => consulta()}>
                    Consultar
                </Button>
                {
                    data === undefined && <Alert style={{ marginTop: 15 }} message="Não foi localizado nenhum registro para os dados informados." type="error" />
                }
            </Flex>
        </React.Fragment>
    }


    function renderResultado() {
        return <React.Fragment>
            <Result
                status="success"
                title={"Comunicação de Responsabilidade Técnica"}
                subTitle={<div>{data.nrt}</div>}
                extra={[
                    <Alert type='info' description={
                        <Flex vertical align='center' justify='center'>
                            <Flex>Profissional:</Flex>
                            <Flex><b>{data.nome}</b></Flex>
                            <Flex style={{marginTop:15}}>Empresa:</Flex>
                            <Flex><strong>{data.cnpj}</strong></Flex>
                            <Flex><b>{data.razao}</b></Flex>
                            <Flex style={{marginTop:15}}>Validade até 31 de março de {parseInt(data.vigencia)+1}</Flex>

                             <Flex style={{marginTop:25}} vertical>
                                <b>AUTENTICAÇÃO</b>
                                <b>{codigo}</b></Flex>
                        </Flex>
                    }>

                    </Alert>

                ]}
            />
        </React.Fragment>
    }


    return (<Flex vertical gap={5}>
        <div
            style={{
                justifyContent: 'center',
                padding: 24,
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>

            <div style={{
                display: 'flex', justifyContent: 'center', flexDirection: 'column',
                maxWidth: 500, alignItems: 'center'
            }}>
                {data ? renderResultado() : renderConsultar()}
            </div>

        </div>
    </Flex>


    )
}


export default ConsultaCRTCtrl